import { useCallback, useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Col } from 'antd'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-transition-group'

import ImageType from '../types/ImageType'
import CustomTypography from './widgets/CustomTypography'
import BynderPicture from 'common/widgets/BynderPicture/BynderPicture'
import classNames from './styles.module.scss'


Person.propTypes = {
  image: ImageType,
  name: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func.isRequired,
}

export default function Person({
  image = {},
  name = undefined,
  title = undefined,
  onClick,
}) {
  const person = useRef()
  const outer = useRef()
  const [isSelected, setIsSelected] = useState(false)

  const handleClick = useCallback(() => {
    if(!isSelected) {
      if(person.current && outer.current) {
        outer.current.style.minHeight = `${person.current.getBoundingClientRect().height}px`
      }
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
      document.documentElement.style.overflow = 'hidden'
      document.documentElement.style.paddingRight = `${scrollbarWidth}px`
    } else {
      document.documentElement.style.overflow = 'auto'
      document.documentElement.style.paddingRight = ''
    }
    setIsSelected(!isSelected)
    onClick()
  }, [isSelected, onClick])

  useEffect(() => {
    return () => {
      document.documentElement.style.overflow = 'auto'
      document.documentElement.style.paddingRight = ''
    }
  }, [])

  return (
    <Col span={24} sm={12} lg={6}>
      <div ref={outer} className={classNames.outer}>
        <CSSTransition
          in={isSelected}
          timeout={450}
          classNames={{
            enter: classNames.personEnter,
            enterActive: classNames.personEnterActive,
            enterDone: classNames.personEnterDone,
            exit: classNames.personExit,
            exitActive: classNames.personExitActive,
            exitDone: classNames.personExitDone,
          }}
          onExited={() => {
            if(outer.current) {
              outer.current.style.minHeight = ''
            }
          }}
        >
          <div
            ref={person}
            className={cx(classNames.person, isSelected && classNames.selected)}
            onClick={handleClick}
          >
            <div
              className={classNames.personImage}
            >
              <BynderPicture
                image={image}
                desktopImage={{
                  maxWidth: 450,
                  maxHeight: 450,
                  sizes: '450px',
                }}
                mobileImage={{
                  maxWidth: 450,
                  maxHeight: 450,
                  sizes: '450px',
                }}
              />
            </div>
            <div className={classNames.personDetails}>
              <CustomTypography variant="name">{name}</CustomTypography>
              <CustomTypography variant="title" className={classNames.title}>{title}</CustomTypography>
            </div>
            <div className={classNames.iconContainer}>
              <FontAwesomeIcon icon="arrow-left" className={classNames.icon} />
            </div>
          </div>
        </CSSTransition>
      </div>
    </Col>
  )
}
